import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';

import { Outlet } from 'react-router-dom';
import { OutletContextModel } from './models/OutletContextModel';
import { AuthContext } from './core/context/authContext';
import Overlay from './components/Overlay/Overlay';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import customTheme from '../src/themes/custom_survey_theme.json';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import emailjs from "@emailjs/browser";

function App() {
  const [selectedTheme, setSelectedTheme] = useState(customTheme)

  const { status } = useContext(AuthContext);
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  useEffect(() => emailjs.init("RqzuuTsfVXrZzheBX"), []);

  return (
    <>
      <Navbar />
      <ToastContainer theme='dark' />
      {(status === 'checking') ?
        <Overlay message='Verificando sesión' />
        : ''}
      {(isFetching || isMutating) ?
        <Overlay message='Cargando' />
        : ''}
      <Outlet context={{ theme: selectedTheme } satisfies OutletContextModel} />
    </>
  );
}

export default App;
